import type { ID, NodeItem } from '@octopus-do/octopus-project-core'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import type { AppState } from '@store/types'
import { call, put, select } from 'redux-saga/effects'

import API from '@/api'
import { InternalGa4Actions } from '../actions'
import type { Ga4ReportResponse } from '../types'
import { buildReportPages } from '../utils'

export function* fetchReport() {
  const projectId: ID | null = yield select(
    migrationProjectSelector.getProjectId
  )

  if (projectId === null) {
    return
  }

  const nodes: NodeItem[] = yield select(
    (state: AppState) => state.manager.project.nodes
  )

  try {
    const response: Ga4ReportResponse = yield call(
      API.GoogleAnalytics.report,
      projectId,
      buildReportPages(nodes)
    )

    yield put(InternalGa4Actions.reportLoaded(response))

    return response.status
  } catch {
    yield put(InternalGa4Actions.reportFailed('error'))
  }
}
